import { render, staticRenderFns } from "./DetailGenerator.vue?vue&type=template&id=b24727ac&scoped=true&"
import script from "./DetailGenerator.vue?vue&type=script&lang=js&"
export * from "./DetailGenerator.vue?vue&type=script&lang=js&"
import style0 from "./DetailGenerator.vue?vue&type=style&index=0&id=b24727ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24727ac",
  null
  
)

export default component.exports